import { allStyles } from '../queries'
import { useFilterStore } from '../../state/filterStore'
import { InputGetAll, StyleConnection } from 'src/types/schema/graphql'
import { apiRequest, RequestInput } from 'src/api/apiRequest'

export const getStyles = async () => {
    const { setAllBrewStyles } = useFilterStore.getState()
    const input: RequestInput<InputGetAll> = {
        query: allStyles,
        args: {
            input: {
                limit: 1000,
            },
        },
        file: 'getStyles.ts',
        endpoint: 'getStyles',
        noAlerts: true,
    }
    const { data } = await apiRequest<StyleConnection, InputGetAll>(input)
    if (data) setAllBrewStyles(data?.items)
}
